// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__ZQAgq","range":"MonthRangeSwitch_range__cHIER","disabled":"MonthRangeSwitch_disabled__3MBKp"};